export default __webpack_public_path__ + "static/media/redux.cae23159.png";